import { ENDPOINTS } from 'src/constants/endpoints'

import type { IPortfolioNewsListResponseDTO } from 'src/app/home/pages/portfolio-news/domain/contracts/portfolio-news'
import { http } from 'src/interfaces/http'

export interface IGetPortfolioNewsParams {
  page: number
  pageSize: number
  search?: string
  company?: string
}

export const getPortfolioNews = async (
  params: IGetPortfolioNewsParams,
): Promise<IPortfolioNewsListResponseDTO> => {
  const { data } = await http.get<IPortfolioNewsListResponseDTO>(
    ENDPOINTS.hanwha.portfolioNews,
    {
      params: {
        page: params.page,
        page_size: params.pageSize,
        ...(params.search ? { search: params.search } : {}),
        ...(params.company ? { company: params.company } : {}),
      },
    },
  )
  return data
}
